import { resolveNoContent, resolveWithBody } from "./Utils/utils";
import { usePromisedRequest as promiseRequest } from "../Common/request";
import { Bundle, TechAccountMode } from "../Common/consts";

//Source: Panel\Events\TechAccount\ReadOnlyTechAccount
export type TechAccount = {
    id: string;
    username: string;
    mode: TechAccountMode;
    bundles: Bundle[];
};

export default {
    getTechAccountsForEvent(eventId: number): Promise<TechAccount[]> {
        return promiseRequest<TechAccount[]>({
            url: `/api/admin/events/${eventId}/tech-accounts`,
            method: "get",
            json: true,
        }).then(resolveWithBody());
    },
    deleteTechAccount(eventId: number, id: string): Promise<void> {
        return promiseRequest<void>({
            url: `/api/admin/events/${eventId}/tech-accounts/${id}`,
            method: "delete",
            json: true,
        }).then(resolveNoContent());
    },
    createTechAccount(eventId: number, username: string, password: string, mode: TechAccountMode, bundles: Bundle[]): Promise<TechAccount> {
        return promiseRequest<TechAccount>({
            url: `/api/admin/events/${eventId}/tech-accounts`,
            method: "post",
            json: {
                eventId: eventId,
                username: username,
                plainPassword: password,
                mode: mode,
                bundles: bundles,
            },
        }).then(resolveWithBody());
    },
    updateAccessMode(eventId: number, id: string, mode: TechAccountMode, bundles: Bundle[]): Promise<TechAccount> {
        return promiseRequest<TechAccount>({
            url: `/api/admin/events/${eventId}/tech-accounts/${id}/access-mode`,
            method: "put",
            json: {
                mode,
                bundles,
            },
        }).then(resolveWithBody());
    },
};
